import React, { useState } from 'react';
import ModalOverlay from '../../shared/ModalOverlay';
import { Vendor } from '../../types';

interface VendorListModalProps {
  active: boolean;
  onClose: () => void;
  vendors: Vendor[];
  onAdd: () => void;
  onEdit: (vendor: Vendor) => void;
  onDelete: (id: number) => void;
  onShowInfo: (vendor: Vendor, type: 'location' | 'shipping') => void;
}

const VendorListModal: React.FC<VendorListModalProps> = ({
  active, onClose, vendors, onAdd, onEdit, onDelete, onShowInfo,
}) => {
  const [typeFilter, setTypeFilter] = useState('');
  const [nameSearch, setNameSearch] = useState('');

  let filtered = vendors;
  if (typeFilter) filtered = filtered.filter((v) => v.vendor_type === typeFilter);
  if (nameSearch) filtered = filtered.filter((v) => (v.vendor_name || '').toLowerCase().includes(nameSearch.toLowerCase()));

  return (
    <ModalOverlay active={active} onClose={onClose}>
      <div className="modal modal-narrow">
        <div className="modal-header">
          <h2>Vendors</h2>
          <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
            <button className="btn btn-primary btn-sm" onClick={onAdd} title="Add new vendor">+</button>
            <button className="modal-close" onClick={onClose}>&times;</button>
          </div>
        </div>
        <div style={{ padding: '0.75rem 1.5rem 0' }}>
          <div className="poc-list-filters">
            <div className="form-group" style={{ flex: 1 }}>
              <label>Vendor Type</label>
              <select value={typeFilter} onChange={(e) => setTypeFilter(e.target.value)}>
                <option value="">All Types</option>
                <option value="Component Maintenance">Component Maintenance</option>
                <option value="145-MRO">145-MRO</option>
              </select>
            </div>
            <div className="form-group" style={{ flex: 1 }}>
              <label>Name Search</label>
              <input type="text" placeholder="Type to search…" value={nameSearch} onChange={(e) => setNameSearch(e.target.value)} />
            </div>
          </div>
        </div>
        <div style={{ padding: '0.5rem 1.5rem 1rem', maxHeight: '400px', overflowY: 'auto' }}>
          {!filtered.length ? (
            <p style={{ color: 'var(--text-dim)', textAlign: 'center', padding: '1rem' }}>No vendors found.</p>
          ) : (
            filtered.map((v) => (
              <div key={v.id} className="poc-list-item">
                <div className="poc-list-item-info">
                  <span className="poc-list-item-name">{v.vendor_name}</span>
                  <span className="poc-list-item-vendor">
                    {v.vendor_type}{v.loc_city ? ` · ${v.loc_city}${v.loc_state ? `, ${v.loc_state}` : ''}` : ''}
                  </span>
                </div>
                <div style={{ display: 'flex', gap: '0.3rem' }}>
                  <button className="btn-icon vendor-loc-btn" title="Location" onClick={() => onShowInfo(v, 'location')}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" /><polyline points="9 22 9 12 15 12 15 22" />
                    </svg>
                  </button>
                  <button className="btn-icon vendor-ship-btn" title="Shipping" onClick={() => onShowInfo(v, 'shipping')}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <rect x="1" y="3" width="15" height="13" /><polygon points="16 8 20 8 23 11 23 16 16 16 16 8" /><circle cx="5.5" cy="18.5" r="2.5" /><circle cx="18.5" cy="18.5" r="2.5" />
                    </svg>
                  </button>
                  <button className="btn-icon edit" title="Edit vendor" onClick={() => onEdit(v)}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" /><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4z" />
                    </svg>
                  </button>
                  <button className="btn-icon delete" title="Delete" onClick={() => onDelete(v.id)}>&times;</button>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </ModalOverlay>
  );
};

export default VendorListModal;
